// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeJoinGrantRegenerateBody = {
  poolId: string;
};

export type typeJoinGrantRegenerateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { joinCode: string; joinUrl: string; createdAt: string };
};

export type typeJoinGrantRegenerateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeJoinGrantRegenerateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeJoinGrantRegenerateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaJoinGrantRegenerateBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createJoinGrantRegenerate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaJoinGrantRegenerateBody);
  }

  return async function postJoinGrantRegenerate(
    payload: typeJoinGrantRegenerateBody,
  ): Promise<
    typeJoinGrantRegenerateOutput200 | typeJoinGrantRegenerateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postJoinGrantRegenerate" failed before calling the network. #d78967a86c20`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d78967a86c20" },
        },
        data: null,
      } as typeJoinGrantRegenerateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/join-grant/regenerate`,
      httpMethod: "POST",
      options,
    })) as typeJoinGrantRegenerateOutput200 | typeJoinGrantRegenerateOutput400;
  };
}
